import React from 'react'

function Vision() {
  return (
    <section className='internal-page-wrapper'>
            <div className='container'>
                <div className='row h-100 align-items-center justify-cont justify-content-center'>
                    <div className='col-12 mt-5 pt-5'>
                        <h1 className='font-weight-bold center'>Vision</h1>
                    </div>
                </div>
            </div>
        </section>
  )
}

export default Vision